import { render, staticRenderFns } from "./mo-address-form.html?vue&type=template&id=22f6cbd1&external"
import script from "./mo-address-form.ts?vue&type=script&lang=ts&external"
export * from "./mo-address-form.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports